export default __webpack_public_path__ + "static/media/Qafilaty-13.207e91da.png";